<template>
  <div class="report-download-container">
    <el-card shadow="always" class="history-card">
      <div slot="header" class="card-header">
        <i class="el-icon-folder-opened header-icon"></i>
        <span class="header-title">歷史月報圖表</span>
      </div>

      <el-table
        v-loading="loading"
        :data="pagedReports"
        border
        stripe
        highlight-current-row
        class="history-table"
        empty-text="目前沒有可下載的月報圖表"
      >
        <el-table-column
          prop="name"
          label="檔案名稱"
          min-width="320"
          header-align="center"
        >
          <template v-slot="scope">
            <div class="file-name-cell">
              <i :class="getFileIcon(scope.row.rawName)" class="file-type-icon"></i>
              <span class="report-display-name">{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="modified"
          label="生成時間"
          width="200"
          align="center"
        />
        
        <el-table-column
          prop="size"
          label="檔案大小"
          width="120"
          align="center"
        />

        <el-table-column label="操作" width="150" align="center">
          <template v-slot="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-download"
              @click="downloadReport(scope.row)"
            >
              下載報告
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="reportList.length"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ReportDownloadCenter',
  data() {
    return {
      loading: false,
      reportList: [],
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    pagedReports() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.reportList.slice(start, end);
    },
  },
  methods: {
    async fetchReports() {
      this.loading = true;
      try {
        const res = await fetch('https://api-thsr-main.geosupply.com.tw/api/zip/list', {
          headers: {
            'Authorization': localStorage.getItem('jwt'),
          },
        });
        const data = await res.json();

        if (data.success && data.files) {
          this.reportList = data.files
            .filter(f => f.name.toLowerCase().endsWith('.zip'))
            .map(f => {
              const date = new Date(f.modified);
              const formattedDate = date.toLocaleString('zh-TW', {
                year: 'numeric', month: 'numeric', day: 'numeric',
                hour: 'numeric', minute: 'numeric', second: 'numeric',
                hour12: false,
              });

              return {
                name: this.formatReportName(f.name),
                rawName: f.name,
                url: f.url,
                size: f.sizeKB,
                modified: formattedDate,
                mtimeMs: f.mtimeMs,
              };
            })
            .sort((a, b) => b.mtimeMs - a.mtimeMs);
        } else {
          this.reportList = [];
        }
      } catch (err) {
        console.error('載入報告失敗:', err);
        this.$message.error('發生錯誤');
      } finally {
        this.loading = false;
      }
    },

    formatReportName(filename) {
      const match = filename.match(/高鐵邊坡監測(\d{4})(\d{2})(\d{2})_月報圖表/);
      
      if (match) {
        const year = match[1];
        const month = match[2];
        const day = match[3];
        return `${year}年${month}月${day}日 高鐵邊坡監測月報圖表`;
      }

      return filename.replace('.zip', '');
    },

    getFileIcon(filename) {
      return 'el-icon-box';
    },

    handlePageChange(page) {
      this.currentPage = page;
    },

    downloadReport(row) {
      const a = document.createElement('a');
      a.href = row.url;
      a.download = row.rawName; 
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
  mounted() {
    this.fetchReports();
  },
};
</script>

<style scoped>
.report-download-container {
  padding: 40px;
  background-color: #f0f2f5;
  min-height: 100vh;
}

.history-card {
  max-width: 1100px;
  margin: 0 auto;
  border-radius: 12px;
}

.card-header {
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #2c3e50;
}

.header-icon {
  font-size: 24px;
  margin-right: 12px;
  color: #67c23a;
}

.file-name-cell {
  display: flex;
  align-items: center;
  padding: 5px 0;
}

.file-type-icon {
  font-size: 20px;
  margin-right: 12px;
  color: #e6a23c;
}

.report-display-name {
  font-weight: 500;
  color: #303133;
}

.history-table {
  margin-top: 15px;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.el-button--success {
  font-weight: bold;
}
</style>